import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import BaseModal, { ModalActions, SaveButton } from "../../../containers/UI/Modal/BaseModal";
import * as actions from "../../../store/actions/auth";
import classes from "./TwoFactorModal.css";

class TwoFactorModal extends Component {

  state = {
    digits: ['', '', '', '', '', '']
  }

  // Refs for digit inputs
  digitRefs = [createRef(), createRef(), createRef(), createRef(), createRef(), createRef()];

  componentDidUpdate(prevProps) {
    // When modal opens, reset digits and focus first input
    if (this.props.isOpen && !prevProps.isOpen) {
      this.setState({ digits: ['', '', '', '', '', ''] });
      setTimeout(() => {
        this.digitRefs[0].current?.focus();
      }, 100);
    }
  }

  // Digit Input Handling

  handleDigitChange = (index, value) => {
    const digit = value.replace(/\D/g, '').slice(-1);
    
    const newDigits = [...this.state.digits];
    newDigits[index] = digit;
    this.setState({ digits: newDigits });

    // Auto-focus next input
    if (digit && index < 5) {
      this.digitRefs[index + 1].current?.focus();
    }
  }

  handleDigitKeyDown = (index, event) => {
    // Backspace - go to previous input
    if (event.key === 'Backspace' && !this.state.digits[index] && index > 0) {
      this.digitRefs[index - 1].current?.focus();
    }
    // Arrow keys navigation
    if (event.key === 'ArrowLeft' && index > 0) {
      this.digitRefs[index - 1].current?.focus();
    }
    if (event.key === 'ArrowRight' && index < 5) {
      this.digitRefs[index + 1].current?.focus();
    }
    // Enter to submit
    if (event.key === 'Enter' && this.code.length === 6) {
      this.handleSubmit();
    }
  }

  handleDigitPaste = (event) => {
    event.preventDefault();
    const pastedData = event.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
    
    if (pastedData) {
      const newDigits = [...this.state.digits];
      for (let i = 0; i < 6; i++) {
        newDigits[i] = pastedData[i] || '';
      }
      this.setState({ digits: newDigits });
      
      const focusIndex = Math.min(pastedData.length, 5);
      this.digitRefs[focusIndex].current?.focus();
    }
  }

  get code() {
    return this.state.digits.join('');
  }

  // Actions

  handleSubmit = () => {
    if (this.props.loading || this.code.length !== 6) return;
    this.props.verify2FA(this.props.userId, this.code);
  }

  render() {
    const { isOpen, loading, error } = this.props;

    return (
      <BaseModal
        isOpen={isOpen}
        className={classes.modal}
        unescapable
      >
        <div className={classes.content}>
          <h2 className={classes.title}>Two-Factor Authentication</h2>
          <p className={classes.description}>
            Enter the 6-digit code from your authenticator app
          </p>

          <div className={classes.otpContainer}>
            {this.state.digits.map((digit, index) => (
              <input
                key={index}
                ref={this.digitRefs[index]}
                type="text"
                inputMode="numeric"
                maxLength="1"
                className={classes.otpInput}
                disabled={loading}
                value={digit}
                onChange={(e) => this.handleDigitChange(index, e.target.value)}
                onKeyDown={(e) => this.handleDigitKeyDown(index, e)}
                onPaste={this.handleDigitPaste}
              />
            ))}
          </div>

          {error && (
            <div className={classes.error}>
              <p>{error}</p>
            </div>
          )}

          <ModalActions>
            <SaveButton 
              onClick={this.handleSubmit}
              disabled={loading || this.code.length !== 6}
            >
              {loading ? "Verifying..." : "Verify"}
            </SaveButton>
          </ModalActions>
        </div>
      </BaseModal>
    );
  }
}

// Redux

const mapStateToProps = (state) => ({
  isOpen: state.auth.requiresTwoFactor,
  userId: state.auth.twoFactorUserId,
  loading: state.auth.loading,
  error: state.auth.requiresTwoFactor ? state.auth.authError : null
});

const mapDispatchToProps = (dispatch) => ({
  verify2FA: (userId, code) => dispatch(actions.verify2FA(userId, code))
});

export default connect(mapStateToProps, mapDispatchToProps)(TwoFactorModal);